import { render, staticRenderFns } from "./bindWechatOpenIdAndPhone.vue?vue&type=template&id=2eae1017&"
import script from "./bindWechatOpenIdAndPhone.vue?vue&type=script&lang=js&"
export * from "./bindWechatOpenIdAndPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports